import React, { ChangeEvent, FC, useRef } from 'react';
import styled from '@emotion/styled';
import Flex from '@vromo/ui/components/Flex';

const LOCALE_CLEAR = 'clear';

const Image = styled.img`
    align-self: flex-start;
    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAADZJREFUOBFjfPny5X8GPEBMTAyPLAMDE15ZIiRHDRgMgcj4HwjwxdarV6/wSY+mA2DoDIOkDACk4wrVehQ8IgAAAABJRU5ErkJggg==');
    margin: 6px 0;
    max-height: 80px;
    max-width: 100%;
`;

const ClearLink = styled.a`
    align-self: flex-start;
    margin: 6px 0;
`;

interface Props {
    url: string;
    onChange: ({ url, file }: { url: string; file?: File }) => void;
}

const ImageEditor: FC<Props> = ({ url, onChange }) => {
    const inputRef = useRef<HTMLInputElement>(null);

    function clear() {
        if (inputRef.current) inputRef.current.value = '';
    }

    function fileSelected(e: ChangeEvent<HTMLInputElement>) {
        if (e.target.files?.length) {
            const file = e.target.files[0] as File;

            const reader = new FileReader();

            reader.onload = (e2) => {
                onChange({ url: (e2.target!.result as string) || '', file });
                clear();
            };

            reader.readAsDataURL(file);
        }
    }

    return (
        <Flex direction="column">
            <Image src={url} />

            {url ? (
                <ClearLink onClick={() => onChange({ url: '' })}>
                    <small>{LOCALE_CLEAR}</small>
                </ClearLink>
            ) : null}

            <input
                ref={inputRef}
                type="file"
                onChange={fileSelected}
                accept="image/png, image/jpeg"
                style={{ marginBottom: 8 }}
            />
        </Flex>
    );
};

export default ImageEditor;
